import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { MobileNav } from '../components/MobileNav';
export function DecodeDetails() {
  const navigate = useNavigate();
  const [dateOfBirth, setDateOfBirth] = useState('1990-06-15');
  const [timeOfBirth, setTimeOfBirth] = useState('10:30');
  const [timeUnknown, setTimeUnknown] = useState(false);
  const [placeOfBirth, setPlaceOfBirth] = useState('Mumbai, India');
  const [showDateError, setShowDateError] = useState(false);
  const [showPlaceError, setShowPlaceError] = useState(false);
  const isValid = dateOfBirth.trim() !== '' && placeOfBirth.trim() !== '';
  const handleSubmit = () => {
    if (!dateOfBirth.trim()) {
      setShowDateError(true);
      return;
    }
    if (!placeOfBirth.trim()) {
      setShowPlaceError(true);
      return;
    }
    sessionStorage.setItem('decodeName', '');
    sessionStorage.setItem('decodeDateOfBirth', dateOfBirth);
    sessionStorage.setItem('decodeTimeOfBirth', timeUnknown ? '' : timeOfBirth);
    sessionStorage.setItem('decodeTimeUnknown', timeUnknown.toString());
    sessionStorage.setItem('decodePlaceOfBirth', placeOfBirth);
    navigate('/decode/reveal');
  };
  return <>
      <Helmet data-id="element-893">
        <title data-id="element-894">Start Your Decode | Lazy Monk Labs</title>
      </Helmet>

      <div className="min-h-screen bg-[#F8F7F4] text-[#444444] selection:bg-[#B89C5D]/20" data-id="element-895">
        <div className="relative z-50" data-id="element-896">
          <MobileNav data-id="element-897" />
        </div>

        <main className="pt-24 sm:pt-32 pb-24 sm:pb-32 px-6 sm:px-8" data-id="element-898">
          <div className="max-w-md mx-auto" data-id="element-899">
            {/* Title */}
            <header className="mb-12 sm:mb-16" data-id="element-900">
              <h1 className="text-2xl sm:text-3xl text-[#111111] uppercase tracking-[0.08em] font-medium mb-4" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-901">
                Start Your Decode
              </h1>
              <p className="text-sm sm:text-base text-[#666666] font-light leading-relaxed" data-id="element-902">
                This reveals how your system is wired — especially under
                pressure.
              </p>
            </header>

            {/* Form */}
            <section className="space-y-10" data-id="element-903">
              {/* Social proof */}
              <p className="text-xs text-[#888888] pb-2 border-b border-[#111111]/10" data-id="element-904">
                Used by 100+ early testers. Described as "a clean mirror."
              </p>
              {/* DATE */}
              <div className="space-y-2" data-id="element-905">
                <label htmlFor="dateOfBirth" className="block text-xs text-[#888888] uppercase tracking-wider" data-id="element-906">
                  Date of birth
                </label>
                <input type="date" id="dateOfBirth" value={dateOfBirth} onChange={e => {
                setDateOfBirth(e.target.value);
                setShowDateError(false);
              }} className="w-full bg-transparent border-0 border-b border-[#111111]/15 text-[#111111] text-base py-3 px-0 focus:outline-none focus:border-[#111111]/40 transition-colors rounded-none" data-id="element-907" />
                {showDateError && <p className="text-sm text-[#888888]" data-id="element-908">
                    Date of birth is required.
                  </p>}
              </div>

              {/* TIME */}
              <div className="space-y-2" data-id="element-909">
                <label htmlFor="timeOfBirth" className="block text-xs text-[#888888] uppercase tracking-wider" data-id="element-910">
                  Time of birth
                </label>
                <input type="time" id="timeOfBirth" value={timeOfBirth} onChange={e => setTimeOfBirth(e.target.value)} disabled={timeUnknown} className="w-full bg-transparent border-0 border-b border-[#111111]/15 text-[#111111] text-base py-3 px-0 focus:outline-none focus:border-[#111111]/40 transition-colors rounded-none disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-911" />
                <p className="text-xs text-[#AAAAAA]" data-id="element-912">
                  Time improves precision but isn't required.
                </p>
                <label className="flex items-center gap-3 cursor-pointer pt-1" data-id="element-913">
                  <input type="checkbox" checked={timeUnknown} onChange={e => {
                  setTimeUnknown(e.target.checked);
                  if (e.target.checked) {
                    setTimeOfBirth('');
                  }
                }} className="w-4 h-4 accent-[#888888]" data-id="element-914" />
                  <span className="text-xs text-[#888888]" data-id="element-915">
                    I don't know my time of birth
                  </span>
                </label>
              </div>

              {/* PLACE */}
              <div className="space-y-2" data-id="element-916">
                <label htmlFor="placeOfBirth" className="block text-xs text-[#888888] uppercase tracking-wider" data-id="element-917">
                  Place of birth
                </label>
                <input type="text" id="placeOfBirth" value={placeOfBirth} onChange={e => {
                setPlaceOfBirth(e.target.value);
                setShowPlaceError(false);
              }} placeholder="City, Country" className="w-full bg-transparent border-0 border-b border-[#111111]/15 text-[#111111] text-base py-3 px-0 placeholder-[#CCCCCC] focus:outline-none focus:border-[#111111]/40 transition-colors rounded-none" data-id="element-918" />
                {showPlaceError && <p className="text-sm text-[#888888]" data-id="element-919">
                    Place of birth is required.
                  </p>}
              </div>
            </section>

            {/* CTA */}
            <section className="pt-14" data-id="element-920">
              <button onClick={handleSubmit} disabled={!isValid} className="w-full px-8 py-5 bg-[#111111] text-[#F8F7F4] text-sm uppercase tracking-widest hover:bg-[#222222] transition-colors disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-921">
                Generate My Reveal
              </button>

              {/* Micro-trust — at decision point */}
              <p className="text-xs text-[#888888] text-center mt-4" data-id="element-922">
                We don't store this unless you choose to save your decode.
              </p>
            </section>
          </div>
        </main>
      </div>
    </>;
}